console.log('js loaded');

//Import
import gsap from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {Flip} from "gsap/Flip";
import {Scroll} from "./Scroll";
import {SplitText} from "gsap/SplitText";


gsap.registerPlugin(ScrollTrigger,Flip,SplitText);

gsap.to('.title',{opacity:1,duration:.5})


let spT2 = new SplitText(".home__hero-title", { type: "lines", linesClass: "lineChild" });
let spT1 = new SplitText(".home__hero-title", { type: "lines", linesClass: "lineParent" });

gsap.set(spT1.lines,{overflow:"hidden"});
gsap.set(spT2.lines,{scale:.5,opacity:0});
gsap.set('.header',{ opacity: 0 })

var intl = gsap.timeline();

intl
    .add('start')
    .to(spT2.lines,{
        scale:1,
        opacity:1,
        duration: 1.5,
        ease: "power2.inOut",
        stagger: {
            each: 0.1,
            from: "end"
        }
    },'start')
    .to('.header',{
        
        opacity:1,
        duration: 1.5,
        ease: "power2.inOut",
        stagger: {
            each: 0.1
        }
    },'start')


if (document.querySelectorAll('.links').length > 0) {
    const img1 = document.querySelector(".img-1");
    const img2 = document.querySelector(".img-2");
    const dur = 0.6

    let tl1 = gsap.timeline({
      reversed: true,
    });
    let tl2 = gsap.timeline({
      reversed: true,
    });

    tl1
      .fromTo(".img-1", {width: "50%" }, { duration: dur, width: "70%" })
      .fromTo(".img-2", {width: "50%" }, { duration: dur, width: "30%" }, "<");

    tl2
      .to(".img-2", { duration: dur, width: "70%" })
      .to(".img-1", { duration: dur, width: "30%" }, "<");

    img1.addEventListener("mouseenter", () => {
      anim1();
    });

    img1.addEventListener("mouseleave", () => {
      anim1();
    });

    img2.addEventListener("mouseenter", () => { 
      anim2();
    });
    img2.addEventListener("mouseleave", () => {
      anim2();
    });

    function anim1(){
      tl1.reversed(!tl1.reversed());
    }

    function anim2(){
      tl2.reversed(!tl2.reversed());
    }
}


setTimeout(()=>{
    if (document.querySelectorAll('.stagger-in').length > 0) {
        document.querySelectorAll('.stagger-in').forEach(el=>{
            let elements = el.querySelectorAll('.stagger-in__el')
            gsap.from(elements, {
                opacity: 0,
                duration: .8,
                yPercent:50,
                stagger: {
                    each: 0.1
                },
                scrollTrigger: {
                    trigger: el,
                    markers: false,
                    start: "top 75%",
                }
            });

        });
    }

    Scroll.scrollTo(0, {
        immediate:true,
    })

    let elements = document.querySelectorAll('.element');

    elements.forEach((el,i)=>{
        const elementState = Flip.getState(el);

        document.querySelector(el.dataset.target).append(el);

        Flip.from(elementState, {
            duration: 1.5,
            delay: i*0.2,
            ease: "power1.inOut",
        });

        gsap.to(el, {
            opacity: 1,
            duration: 1.5,
            delay: i*0.2,
            ease: "power1.inOut",
        });
    });
},250);


import Swiper from 'swiper';

var swiper = new Swiper('.swiper-container', {
  slidesPerView: 1.5,
  centeredSlides: true,
  loop: true,
  spaceBetween: 0,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
    breakpoints: {
        640: {
          slidesPerView: 1.5,
          spaceBetween: 0,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 0,
        },
    },
});



document.querySelectorAll(".hamburger").forEach((element) => {
  element.addEventListener("click", (event) => {
    element.classList.toggle("is-active");
  });
});

const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
const toggleMenu = document.querySelector('.hamburger');


const tl = gsap.timeline({ reversed: true });
  
  tl
  .from('.header nav', {
    duration: 0.4,
    ease: 'power3.inOut',
    top: '-100%',    
  })
  .from('.header nav li', {
    duration: 0.3,
    opacity: 0,
    y: 20,
    ease: 'power3.inOut',
    stagger: 0.05,    
  });

  function animateIt() {    
    tl.reversed() ? tl.play() : tl.reverse()
  }




var mediaQueryList = window.matchMedia('(min-width: 991px)');

// Set things up on load
if(mediaQueryList.matches) {
  tl.pause(1)
} else {
  toggleMenu.addEventListener('click', animateIt);
  tl.pause(0)
}

function toggleStateOnResize(e) {
  
  if (e.matches) {
    // WIDE SCREEN
    toggleMenu.removeEventListener('click', animateIt);
    tl.pause(1)

  } else {
    // NARROW SCREEN
    toggleMenu.addEventListener('click', animateIt);
    tl.pause(0).reversed(true)
  }
}

mediaQueryList.addListener(toggleStateOnResize);
